import {UUID} from '../../../shared/types/uuid.type';
import {colors, StatusConfigurations} from '../../../shared/components/status/status.component';

export type StreamTranscodingStatus =
  'creating'
  | 'online'
  | 'offline'
  | 'starting'
  | 'stopping'
  | 'stopped'
  | 'deleting'
  | 'deleted'
  | 'error';
export type StreamTranscodingDataSourceStatus = StreamTranscodingStatus | 'draft';

export const streamTranscodingStatusConfigurations: StatusConfigurations<StreamTranscodingDataSourceStatus> = new Map([
  ['draft', {tooltip: 'Inactive', color: colors.grey, isFlickering: false}],
  ['creating', {tooltip: 'Creating', color: colors.yellow, isFlickering: true}],
  ['online', {tooltip: 'Active', color: colors.green, isFlickering: false}],
  ['offline', {tooltip: 'Offline', color: colors.grey, isFlickering: false}],
  ['starting', {tooltip: 'Starting', color: colors.yellow, isFlickering: true}],
  ['stopping', {tooltip: 'Stopping', color: colors.yellow, isFlickering: true}],
  ['stopped', {tooltip: 'Stopped', color: colors.grey, isFlickering: false}],
  ['deleting', {tooltip: 'Deleting', color: colors.yellow, isFlickering: true}],
  ['deleted', {tooltip: 'Deleted', color: colors.grey, isFlickering: false}],
  ['error', {tooltip: 'Error applying transcoding', color: colors.red, isFlickering: false}]
]);

export interface StreamTranscodingConfiguration {
  id: UUID;
  streamId: UUID;
  transcodingPresetId: UUID;
  previewStreamKey: string;
  status: StreamTranscodingStatus;
  errorMessage: string | null;
  createdAt: number;
  updatedAt: number;
}

export interface CreateStreamTranscodingConfigurationDto {
  streamId: UUID;
  transcodingPresetId: UUID;
}

export interface UpdateStreamTranscodingConfigurationDto {
  id: UUID;
  streamId: UUID;
  transcodingPresetId: UUID;
}

export interface StreamTranscodingConfigurationDataSource {
  id: UUID | null;
  streamId: UUID | null;
  streamName: string;
  transcodingPresetId: UUID | null;
  transcodingPresetName: string;
  previewUrl: string | null;
  status: StreamTranscodingDataSourceStatus;
  errorMessage: string | null;
  isEditing: boolean;
  createdAt: number | null;
  updatedAt: number | null;
}

export type StreamTranscodingConfigurationWebSocketAction = 'create' | 'update' | 'delete';

export interface StreamTranscodingConfigurationWebSocketMessage {
  action: StreamTranscodingConfigurationWebSocketAction;
  data: StreamTranscodingConfiguration;
}
